// removed by extract-text-webpack-plugin
module.exports = {"myOfferContainer":"_2i1tDo9e4LiS6fTGucJOTD","myOfferHeading":"_1vj3t1QIpB_Oo7N9LZgwFz","subHeading":"_5J1QZj6tA0TYOC1o05SLa","tableStyle":"_1JJH50CfSmel3AR2gXPtbz","radioButtonColoum":"ArMErr-RiUe7s9UGItEE","radioStyle":"AVerhuF9XTN3u-pe9f5rA","closeButton":"J94gapcwnVCZ-jVBpsWC6","offerListContainer":"_15O3G6vo54R8dKSG95xE8H"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/myOffersList.css
// module id = 913
// module chunks = 0